import React from 'react';
export function ProductIntro() {
  return <section className="bg-gray-50 py-16 px-4 sm:px-6 border-y border-gray-200" data-id="element-209">
      <div className="max-w-3xl mx-auto text-center space-y-8" data-id="element-210">
        <div className="text-5xl mb-4" data-id="element-211">🌱</div>

        <div className="space-y-2" data-id="element-212">
          <h2 className="font-archivo text-4xl sm:text-5xl uppercase text-brand-black" data-id="element-213">
            CRECER JUGANDO
          </h2>
          <p className="text-xl sm:text-2xl font-bold text-gray-600" data-id="element-214">
            100 actividades para estimular el desarrollo infantil
          </p>
        </div>

        <p className="text-lg sm:text-xl text-gray-700 font-medium max-w-2xl mx-auto" data-id="element-215">
          Un kit práctico, imprimible y listo para usar que ayuda a acompañar:
        </p>

        <div className="flex flex-wrap justify-center gap-3 sm:gap-4 max-w-2xl mx-auto" data-id="element-216">
          {['lenguaje', 'creatividad', 'motricidad', 'atención', 'emociones', 'coordinación', 'autonomía'].map(skill => <div key={skill} className="bg-white px-4 py-2 rounded-full shadow-sm border border-gray-200 font-bold text-brand-black flex items-center gap-2" data-id="element-217">
              <span className="text-brand-green" data-id="element-218">✔</span> {skill}
            </div>)}
        </div>

        <p className="font-archivo text-3xl uppercase text-brand-black pt-6" data-id="element-219">
          <span className="highlight-yellow" data-id="element-220">Todo a través del juego.</span>
        </p>
      </div>
    </section>;
}